<div class="act-item">
  @if (isHubspotActor) {
  <span class="act-avatar act-avatar--system">
    <app-hubspot-mark [size]="16" label="Via HubSpot" />
  </span>
  } @else {
  <app-initials-avatar class="act-avatar" [name]="actorName" [size]="28"></app-initials-avatar>
  }

  <div class="act-body">
    <p class="act-sentence">
      <span class="act-actor">{{ actorName }}</span>&ngsp;<span class="act-verb">{{ verb }}</span>@if (subject) {&ngsp;<span class="act-subject">{{ subject }}</span>}
    </p>

    @if (showComment) {
    <div class="act-quote" [class.act-quote--read]="notification.read_at !== null">
      <span>"{{ commentPreview }}"</span>
    </div>
    }

    @if (showStatus) {
    <div class="act-status">
      <span class="act-status-label">Status:</span>
      <span class="status-pill" [ngStyle]="fromPill()">{{ fromStage }}</span>
      <lucide-icon name="arrow-right" [size]="12" style="display: flex;"></lucide-icon>
      <span class="status-pill" [ngStyle]="toPill()">{{ toStage }}</span>
    </div>
    }

    <span class="act-time">{{ relativeTime }}</span>
  </div>
</div>
